
import { AllBlStatusInfo, AllContainerStatusInfo, BlStatusInfo, BookingContainerResponse, ConfirmOrAssignSoResponse, ContainerDetailsModel, ContainerDetailsResponse, ContainerDispatchedToPlantResponse, ContainerStatusInfo, DraftReceivedResponse, FillSealInfoResponse, SoContainerStatusUpdate, InitiateDispatchResponse, ContainerResponse, EtdUpdateRequest, BillNoUpdateRequest, ContaierRegisterRequest, LoadingReportModel, AllLoadingReportResponse, ShipmentDetailsDto, ShippmentDetailsResponse, FilenameDto, ContainerReportResponse, ContainerReportModel, ContainerReportPlantsData, ContainerBarChartDto, ContainerBarChartResponseModel, TopFiveDestinationDto, Containertrnd, ContainerStatusRequest } from '@gtpl/shared-models/logistics';

import { Injectable } from '@nestjs/common';
import { ContainerRepository } from './repository/container.repository';
import { SaleOrderService, saleOrder } from '@gtpl/shared-services/sale-management';
import { StockService } from '@gtpl/shared-services/procurement';
import { ContainerLoadingStatus,MessageRequest, ContainerStatusEnum, ErrorResponse, BlStatusEnum, SoStatusEnum, SaleOrderStatusEnum, UomEnum, JobTypesEnum, EmployeeRolesEnum, MessageParameters, GlobalVariableValues } from '@gtpl/shared-models/common-models';
import { BookContainerDto } from './dto/book-container.dto';
import { ContainerAdapter } from './dto/container.adapter';
import { DispatchedToPlant } from './dto/container-dispatched-to-plant.dto';
import { ConfirmOrAssignSoData } from './dto/confirm-or-assign-so.dto';
import { ContainerLogRepository } from './repository/container-log.repository';
import { ContainerDTO } from './dto/container.dto';
import { DraftReceived } from './dto/draft-received.dto';
import { containerLogDto } from './dto/container-log.dto';
import { ContainerLogAdapter } from './dto/container-log.adapter';
import { PlantInvoiceDetailsRequest, SaleOrderDropDownDto, saleOrderItemIdRequest, UnitsOfWeightInput } from '@gtpl/shared-models/sale-management';
import { ContainerSoIdRequest } from './dto/container-soId.request';
import { ContainerRegisterRequest } from './dto/container-register.request';
import { DestinationService } from '@gtpl/shared-services/masters';
import { ContainerIdRequest } from './dto/container-id.request';
;
import { DocumentsListService } from '@gtpl/shared-services/logistics'
import { getManager } from 'typeorm';
import appSettings from 'apps/services/config';
import { UnitRequest } from './dto/unit.id.request';
import { SaleOrderIdRequest } from '@gtpl/shared-models/procurement-management';
import { FGStockService } from '@gtpl/shared-services/warehouse-management';
import { SoIdRequest } from '@gtpl/shared-models/warehouse-management';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ContainerYearRequest } from './dto/container-year-request';
import {  WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import moment = require("moment");
import { Cron } from '@nestjs/schedule';
import { BroadCastMessageRequest, WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { whatsApp } from '../../../../whatsapp';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management'
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';



// import { Container } from './container.entity';
// import { ErrorResponse } from '@gtpl/shared-models/common-models';
// // import (ContainerResponseModel) from '@gtpl/shared-models/logistics-management';
// import { ContainerDTO } from './dto/container.dto';

@Injectable()
export class ContainerService {
    constructor(private repository: ContainerRepository,
        private containerLogRepo: ContainerLogRepository,
        private soService: SaleOrderService,
        private stockService: StockService,
        private fGStockService: FGStockService,
        private adapter: ContainerAdapter,
        private logAdapter: ContainerLogAdapter,
        private destinationService: DestinationService,
        private documentsListService: DocumentsListService,
        private wtsAppBroadCatService: WhatsappBroadCastService,
        private wpService: WhatsAppNotificationService

    ) { }
    // containerRepo: any;
    // containerAdapter: any;
    // itemsAdapter: any;


    // async CreateContainer(containerData: ContainerDTO, isUpdate?: boolean): Promise<ContainerResponseModel> {

    //     const containerEntity = this.containerAdapter.convertDtoToEntity(containerData, isUpdate);
    //     const createResponse = await this.containerRepo.save(containerEntity);

    //     const conItems: Container[] = [];
    //     for (const containerItems of containerData.containerItems) {
    //         const itemsEntity = this.itemsAdapter.convertDtoToEntity(conItems, createResponse.containerId);
    //         const createContainerData = await this.containerRepo.save(itemsEntity);
    //         console.log(createContainerData);
    //     }

    //     console.log(containerEntity);
    //     // save entity
    //     console.log(createResponse);
    //     if (createResponse) {
    //         return new 
    //         ContainerResponseModel(true, 1111, 'Created Successfully', 'Created Successfully');
    //     } else {
    //         throw new ErrorResponse(9999, 'Failed To Create')
    //     }


    // }



    async getAllContainerStatusInfo(): Promise<AllContainerStatusInfo> {
        try {

            const containerDetails = this.repository.createQueryBuilder('Container')
            const soTrackInfo = await this.soService.getSoTrackInfo();
            const containerInfo = await containerDetails.getMany();
            if (soTrackInfo.status || containerInfo.length) {
                let containersInfo: ContainerStatusInfo[] = [];

                for (const container of containerInfo) {

                    let fillSealImages: FilenameDto[] = [];

                    const documentDetails = await this.documentsListService.getDocumentsDetailsForSoId({ saleOrderId: container.saleOrderId });
                    for (const item of documentDetails.data) {
                        const data = new FilenameDto(item.fileName);
                        fillSealImages.push(data);
                    }

                    const SaleOrderItemDetails = await this.soService.getSaleOrderDetailsById({ saleOrderId: container.saleOrderId });
                    let grossWeight = false;
                    for (const item of SaleOrderItemDetails.data.itemData) {
                        if (item.grossWeight > 0) {
                            grossWeight = true;
                        }
                        else {
                            grossWeight = false;
                            break;
                        }
                    }
                    // get sale order details for sale order id
                    const soReq: saleOrder = {
                        saleOrderId: container.saleOrderId
                    }
                    // const saleOrderDetails = await this.soService.getSaleOrderDetailsForId(soReq);
                    const saleOrderDetailsInfo = await this.soService.getSaleOrderInformationById(soReq);
                    console.log('saleOrderDetailsInfo2' + saleOrderDetailsInfo.data.saleOrder + "***" + saleOrderDetailsInfo.data.finalDestination);
                    const containerData = new ContainerStatusInfo(container.containerNumber, container.containerStatus, { saleOrderId: container.saleOrderId, saleOrderNumber: saleOrderDetailsInfo.data.saleOrder }, container.loadingStatus, container.createdUser, container.containerId, container.updatedUser, (saleOrderDetailsInfo) ? saleOrderDetailsInfo.data.saleOrder : '', container.referenceNumber, container.scac, saleOrderDetailsInfo.data.poNo, saleOrderDetailsInfo.data.buyerPoNo, saleOrderDetailsInfo.data.customer, saleOrderDetailsInfo.data.etd, saleOrderDetailsInfo.data.endCustomer, saleOrderDetailsInfo.data.finalDestination, grossWeight, SaleOrderItemDetails.data.unit, container.unitId, fillSealImages, saleOrderDetailsInfo.data.isInvoiced);
                    console.log(containerData);
                    containersInfo.push(containerData);
                }

                if (soTrackInfo.status) {
                    // containersInfo.push(soTrackInfo.data)
                    containersInfo = [...containersInfo, ...soTrackInfo.data]
                }

                return new AllContainerStatusInfo(true, 1111, 'Container Status Info Found Successfully', containersInfo);
            } else {
                throw new ErrorResponse(9999, 'No Data Found')
            }
        } catch (err) {
            return err;
        }

    }
    async getAllContainerStatus(req: UnitRequest): Promise<AllContainerStatusInfo> {
        const manager = getManager();
        let query = `SELECT cn.container_number AS containerNo, st.container_status AS containerStatus,so.sale_order_id AS saleOrderId,so.sale_order_no AS saleOrderNumber,cn.loading_status AS loadingStatus,cn.created_user AS createdUser,cn.container_id AS containerId,cn.updated_user AS updatedUser,inv.po_number AS poNo,cn.reference_number AS referenceNumber,cn.scac AS scac,inv.buyer_po_number AS buyerPoNo,c.client_name AS customer, inv.act_edl_date AS etd,ec.end_customer_name AS endCustomer,d.destination_name AS destination,IF(si.gross_weight_per_kg > 0, true, false) AS grossWeight,u.unit_code_id AS plantId,u.unit_name AS plant, so.is_invoiced AS isInvoiced, GROUP_CONCAT(doc.file_path) AS filePath,co.country_name as country,SUM(si.cases) as poQty, SUM(si.reported_cases) as fgQty,si.sale_order_id as saleorderid,production_status AS productionStatus,inspection_status AS inspectionStatus,ROUND((SUM(si.reported_cases)/SUM(si.cases))*100) AS percent,MAX(si.gross_weight_per_kg)AS grossweightPerKg  FROM ` + appSettings.sales_db + `.sale_order so LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.sale_order_items si ON si.sale_order_id=so.sale_order_id LEFT JOIN ` + appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id LEFT JOIN ` + appSettings.masters_db + `.end_customers ec ON ec.end_customer_id=inv.end_customer_id LEFT JOIN ` + appSettings.masters_db + `.destination d ON d.destination_id=inv.destination LEFT JOIN ` + appSettings.logistics_db + `.container cn ON inv.sale_order_id = cn.sale_order_id LEFT JOIN ` + appSettings.logistics_db + `.documents_list doc ON cn.sale_order_id = doc.sale_order_id LEFT JOIN ` + appSettings.masters_db + `.countries co ON co.country_id = inv.country_id LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=inv.processing_unit LEFT JOIN ` + appSettings.sales_db + `.sale_order_track st ON st.sale_order_id=inv.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.so_inspection sin ON sin.sale_order_id=so.sale_order_id where inv.job_type!='${JobTypesEnum.SUB_JOB}'`;
        console.log(([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)));
        console.log(req.unitId);
        if ((([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1)) {
            query += ` and inv.processing_unit= ${req.unitId}`;
        }

        query += ` group by so.sale_order_id`;
        const queryResult = await manager.query(query);

        return new AllContainerStatusInfo(true, 1111, 'Container Status Info Found Successfully', queryResult);
    }
    async bookContainer(containerInfo: BookContainerDto): Promise<BookingContainerResponse> {
        const bookingEntity = await this.adapter.convertBookingDtoToEntity(containerInfo);
        const response = await this.repository.save(bookingEntity);

        if (response) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.BOOKED
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);

            //container log data
            const containerLogData = new containerLogDto(ContainerStatusEnum.BOOKED, response.containerId, containerInfo.createdUser, containerInfo.updatedUser)

            const logResponse = await this.updateLog(containerLogData);
            return new BookingContainerResponse(true, 1111, 'Container Booked Successfully');
        } else {
            throw new ErrorResponse(9999, 'Failed to book the container');
        }

    }


    async containerDispatchedToPlant(containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
        const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerNumber: containerInfo.containerNumber,
            containerStatus: containerInfo.containerStatus,
        })

        //container log data
        const containerLogData = new containerLogDto(ContainerStatusEnum.DISPATCHED_TO_PLANT, containerInfo.containerId, containerInfo.createdUser, containerInfo.updatedUser)

        const logResponse = await this.updateLog(containerLogData);

        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.DISPATCHED_TO_PLANT
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Container Dispatched To Plant');
        } else {
            throw new ErrorResponse(9999, 'Failed to dispatch the container');
        }
    }

    async updateLog(conLog: containerLogDto) {
        const containerLogEntity = await this.logAdapter.convertDtoEntity(conLog);
        //save container log
        const containerLogResponse = await this.containerLogRepo.save(containerLogEntity);
    }

    async confirmOrAssignSo(containerInfo: ConfirmOrAssignSoData): Promise<ConfirmOrAssignSoResponse> {
        try {
            let response;
            if (containerInfo.saleOrderId != containerInfo.oldSoNumber) {
                const saleInfo = await this.repository.findOne({ where: { saleOrderId: containerInfo.saleOrderId } });
                console.log(saleInfo);
                if (saleInfo) {
                    console.log("**so containers***");
                    const statuses = [ContainerStatusEnum.LOADING, ContainerStatusEnum.LOADED_AND_SEALED, ContainerStatusEnum.SHIPPED];
                    if (!statuses.includes(saleInfo.containerStatus)) {
                        // update container with current changed so
                        response = await this.repository.update({ containerId: containerInfo.containerId }, {
                            // containerStatus: containerInfo.containerStatus,
                            saleOrderId: containerInfo.saleOrderId,
                            updatedUser: containerInfo.updatedUser,
                            loadingStatus: ContainerLoadingStatus.LOADED
                        })
                        const containerStatusSo: SoContainerStatusUpdate = {
                            saleOrderId: containerInfo.saleOrderId,
                            containerStatus: ContainerStatusEnum.LOADING
                        }
                        await this.soService.updateContainerStatus(containerStatusSo)
                        // update old container status
                        const response1 = await this.repository.update({ containerId: saleInfo.containerId }, {
                            // containerStatus: saleInfo.containerStatus,
                            saleOrderId: containerInfo.oldSoNumber,
                            updatedUser: containerInfo.updatedUser,
                            loadingStatus: ContainerLoadingStatus.OPEN
                        })

                    } else {
                        throw new ErrorResponse(9999, "Container status can't be changed, container is in " + `${saleInfo.containerStatus}` + " status. Please Contact Admin");
                    }
                } else {
                    console.log("** No so containers***");
                    // update container with current changed so
                    response = await this.repository.update({ containerId: containerInfo.containerId }, {
                        // containerStatus: containerInfo.containerStatus,
                        saleOrderId: containerInfo.saleOrderId,
                        updatedUser: containerInfo.updatedUser,
                        loadingStatus: ContainerLoadingStatus.LOADED
                    })
                    const containerStatusInSo: SoContainerStatusUpdate = {
                        saleOrderId: containerInfo.oldSoNumber,
                        containerStatus: ContainerStatusEnum.READY_TO_BOOK
                    }
                    const containerStatusSo: SoContainerStatusUpdate = {
                        saleOrderId: containerInfo.saleOrderId,
                        containerStatus: ContainerStatusEnum.LOADING
                    }
                    await this.soService.updateContainerStatus(containerStatusSo)
                    console.log(containerStatusInSo);
                    // update sale tracker status
                    const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
                }
            } else {
                response = await this.repository.update({ containerId: containerInfo.containerId }, {
                    // containerStatus: containerInfo.containerStatus,
                    saleOrderId: containerInfo.saleOrderId,
                    updatedUser: containerInfo.updatedUser,
                    loadingStatus: ContainerLoadingStatus.LOADED
                })
                const containerStatusSo: SoContainerStatusUpdate = {
                    saleOrderId: containerInfo.saleOrderId,
                    containerStatus: ContainerStatusEnum.LOADING
                }
                await this.soService.updateContainerStatus(containerStatusSo)
            }



            if (response.affected) {
                // const containerStatusInSo: SoContainerStatusUpdate = {
                //     saleOrderId: containerInfo.saleOrderId,
                //     // containerStatus: ContainerStatusEnum.LOADING
                // }
                // // update sale tracker status
                // const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
                // //container log data
                // const containerLogData = new containerLogDto(ContainerStatusEnum.LOADING, containerInfo.containerId, containerInfo.createdUser, containerInfo.updatedUser)
                // const logResponse = await this.updateLog(containerLogData);
                return new ConfirmOrAssignSoResponse(true, 1111, 'So Confirmed To Container');
            } else {
                throw new ErrorResponse(9999, 'Failed to Update Container So');
            }
        } catch (error) {
            return error;
        }

    }


    async fillSealInfo(containerInfo: ContainerDTO): Promise<FillSealInfoResponse> {
        const dispatchContainer = await this.adapter.convertFillSealInfoDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerStatus: containerInfo.containerStatus,
            lineSeal: containerInfo.lineSeal,
            eSeal: containerInfo.eSeal,
            driverName: containerInfo.driverName,
            vehicleNumber: containerInfo.vehicleNumber,
            phoneNumber: containerInfo.phoneNumber,
            loadingDate: containerInfo.loadingDate,
            scac: containerInfo.scac
        })

        if (response.affected) {

            //container log data
            const containerLogData = new containerLogDto(containerInfo.containerStatus, containerInfo.containerId, containerInfo.createdUser, containerInfo.updatedUser)

            const logResponse = await this.updateLog(containerLogData);

            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADED_AND_SEALED,
                is_dispatched: true
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new FillSealInfoResponse(true, 1111, 'Seal Info Filled');
        } else {
            throw new ErrorResponse(9999, 'Failed to Fill Seal Info');
        }
    }

    async updateToReadyToBook(containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNumber,
            containerStatus: ContainerStatusEnum.READY_TO_BOOK,
        })

        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.READY_TO_BOOK
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to Ready To Book');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async updateToBooked(containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerNumber: containerInfo.containerNo,
            containerStatus: ContainerStatusEnum.BOOKED,
        })
        console.log(response);
        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.BOOKED
            }
            console.log(containerStatusInSo);

            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to Booked');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }
    async updateStatusToLoading(containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerNumber: containerInfo.containerNo,
            containerStatus: ContainerStatusEnum.LOADING,
            loadingStatus: ContainerLoadingStatus.LOADED
        })
        console.log(response);
        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADING
            }

            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to LOADING');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }


    async updateToDispatchedToPlant(containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNumber,
            containerStatus: ContainerStatusEnum.DISPATCHED_TO_PLANT,
            loadingStatus: ContainerLoadingStatus.OPEN
        })

        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.DISPATCHED_TO_PLANT
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to Container Dispatched To Plant');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async updateToLoading(containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNumber,
            containerStatus: ContainerStatusEnum.LOADING,
            loadingStatus: ContainerLoadingStatus.LOADED
        })

        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADING
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to Loading');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }
    async updateToLoadedAndSealed(containerInfo: ContainerStatusInfo): Promise<ConfirmOrAssignSoResponse> {
        // const dispatchContainer = await this.adapter.convertDispatchToPlantDtoToEntity(containerInfo);
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNumber,
            containerStatus: ContainerStatusEnum.LOADED_AND_SEALED,
        })

        if (response.affected) {
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADED_AND_SEALED
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            return new ConfirmOrAssignSoResponse(true, 1111, 'Updated to Loaded and Sealed');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async initiateDispatch(containerInfo: ContainerStatusInfo): Promise<InitiateDispatchResponse> {
        try {
            const response = await this.repository.update({ containerId: containerInfo.containerId }, {
                containerStatus: ContainerStatusEnum.LOADING
            })
            const containerStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrderId,
                containerStatus: ContainerStatusEnum.LOADING
            }
            // update sale tracker status
            const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
            //container log data
            const containerLogData = new containerLogDto(ContainerStatusEnum.LOADING, containerInfo.containerId, containerInfo.createdUser, containerInfo.updatedUser)

            const logResponse = await this.updateLog(containerLogData);
            return new InitiateDispatchResponse(true, 1111, 'Dispatch Initiated')
        } catch (error) {
            return error
        }

    }

    async shipContainer(containerInfo: ContainerStatusInfo): Promise<ContainerResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            let flag=true;
            const response = await manager.getCustomRepository(ContainerRepository).update({ containerId: containerInfo.containerId }, {containerStatus: ContainerStatusEnum.SHIPPED});
            console.log(response);
            if (response.affected <= 0) {
                flag = false;
                await manager.releaseTransaction();   
                return new ContainerResponse(false, 1110, 'Something went wrong.');
            }
            else{
                const containerStatusInSo: SoContainerStatusUpdate = {
                    saleOrderId: containerInfo.saleOrderId,
                    containerStatus: ContainerStatusEnum.SHIPPED
                }
                // update sale tracker status
                const containerStatusUpdate = await this.soService.updateContainerStatus(containerStatusInSo);
                console.log("containerStatusUpdate" + containerStatusUpdate);
                if (containerStatusUpdate) {

                    const fgStockUpdate = await this.fGStockService.moveLeftOverQtytoDummy(new SoIdRequest(containerInfo.saleOrderId, containerInfo.plantId));
                    if(!fgStockUpdate.status){
                        flag = false;
                        await manager.releaseTransaction();   
                        return new ContainerResponse(false, 1110, 'Something went wrong.');
                        // break;
                    }
                    console.log("fgStockUpdate" + fgStockUpdate.status + "***" + fgStockUpdate.data);

                    //moving left over packing Qty into bulk
                    const PackStockUpdate = await this.stockService.moveLeftOverQtyIntoBulk(new SaleOrderIdRequest(containerInfo.saleOrderId, null))
                    if(!PackStockUpdate.status){
                        flag = false;
                        await manager.releaseTransaction();   
                        return new ContainerResponse(false, 1110, 'Something went wrong.');
                    }

                }
                else{
                    flag = false;
                    await manager.releaseTransaction();   
                    return new ContainerResponse(false, 1110, 'Something went wrong.');
                }

              
                //container log data
                const containerLogData = new containerLogDto(ContainerStatusEnum.SHIPPED, containerInfo.containerId, containerInfo.createdUser, containerInfo.updatedUser)

                const containerLogEntity = await this.logAdapter.convertDtoEntity(containerLogData);
        //save container log
                 const containerLogResponse = await manager.getCustomRepository(ContainerLogRepository).save(containerLogEntity);
                 if(!containerLogResponse.containerLogId){
                    flag = false;
                    await manager.releaseTransaction();   
                    return new ContainerResponse(false, 1110, 'Something went wrong.');
                 }
                // const logResponse = await this.updateLog(containerLogData);
                
            } 
            if(!flag){
                await manager.releaseTransaction();   
                return new ContainerResponse(false, 1110, 'Something went wrong.');
            }
            else{
                await manager.completeTransaction();   
                return new ContainerResponse(true, 1111, 'Container Shipped Successfully');
            }
        } catch (error) {
            console.log(error)
            await manager.releaseTransaction();   
            return error
        }

    }



    // ========================================================
    // ---------------- BL Status Services --------------------
    // ========================================================

    // async getAllContainerBlStatusInfo(): Promise<AllBlStatusInfo> {
    //     const containerInfo = await this.repository.find();
    //     const soTrackInfo = await this.soService.getSoTrackBlStatusInfo();

    //     if (soTrackInfo.status || containerInfo.length) {
    //         const containersInfo: BlStatusInfo[] = [];

    //         for (const container of containerInfo) {
    //             // get sale order details for sale order id
    //             const soReq: saleOrder = {
    //                 saleOrderId: container.saleOrderId
    //             }

    //             const saleOrderDetails = await this.soService.getSaleOrderDetailsForId(soReq);
    //             if (!saleOrderDetails) {
    //                 throw new ErrorResponse(1111, 'Failed to Get Sale Order');
    //             }
    //             const containerData = new BlStatusInfo(container.containerNumber, container.blStatus, saleOrderDetails, container.containerId);
    //             containersInfo.push(containerData);
    //         }
    //         if (soTrackInfo.status) {
    //             for (const soTrack of soTrackInfo.data) {
    //                 containersInfo.push(soTrack)
    //             }
    //         }


    //         return new AllBlStatusInfo(true, 1111, 'Container BL Status Info Found Successfully', containersInfo);
    //     } else {
    //         throw new ErrorResponse(9999, 'No Data Found')
    //     }
    // }

    async getAllContainerBlStatusInfo(): Promise<AllBlStatusInfo> {
        // const manager = getManager();
        // let query = `SELECT cn.container_number AS containerNo, st.container_status AS containerStatus,so.sale_order_id AS saleOrderId,so.sale_order_no AS saleOrderNumber,
        // cn.loading_status AS loadingStatus,cn.created_user AS createdUser,cn.container_id AS containerId,cn.updated_user AS updatedUser,inv.po_number AS poNo,
        // cn.reference_number AS referenceNumber,cn.scac AS scac,inv.buyer_po_number AS buyerPoNo,c.client_name AS customer, inv.act_edl_date AS etd,
        // ec.end_customer_name AS endCustomer,d.destination_name AS destination,IF(si.gross_weight_per_kg > 0, true, false) AS grossWeight,u.unit_code_id AS plantId,u.unit_name AS plant, so.is_invoiced AS isInvoiced, GROUP_CONCAT(file_path) AS filePath, 
        // cn.container_number AS containerNo, blStatus, so.sale_order_no as saleOrderNo, cn.container_id AS containerId, inv.act_edl_date AS etd, oblEtd, blNo, inv.po_number AS customPoNo, d.destination_name AS destination, cn.tracking_no as trackingNo FROM `+ appSettings.sales_db + `.sale_order so 
        // LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id
        // LEFT JOIN `+ appSettings.sales_db + `.sale_order_items si ON si.sale_order_id=so.sale_order_id AND si.gross_weight_per_kg = (SELECT MAX(gross_weight_per_kg) FROM  ` + appSettings.sales_db + `.sale_order_items si WHERE si.sale_order_id = so.sale_order_id)
        // LEFT JOIN `+ appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id
        // LEFT JOIN `+ appSettings.masters_db + `.end_customers ec ON ec.end_customer_id=inv.end_customer_id
        // LEFT JOIN `+ appSettings.masters_db + `.destination d ON d.destination_id=inv.destination
        // LEFT JOIN `+ appSettings.logistics_db + `.container cn ON inv.sale_order_id = cn.sale_order_id
        // LEFT JOIN `+ appSettings.logistics_db + `.documents_list doc ON cn.sale_order_id = doc.sale_order_id
        // LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id=inv.factoryId
        // LEFT JOIN `+ appSettings.sales_db + `.sale_order_track st ON st.sale_order_id=inv.sale_order_id where inv.job_type!='${JobTypesEnum.SUB_JOB}'`;

        // if ((([
        //     EmployeeRolesEnum.ADMIN,
        //     EmployeeRolesEnum.HO_PACKAGING_MANAGER
        // ].indexOf(req.role)) === -1) && !req.unitId) {
        //     query += ` and inv.factoryId= ${req.unitId}`;
        // }

        // query += ` group by so.sale_order_id`;
        // const queryResult = await manager.query(query);








        // const containerInfo = await this.repository.find({ where: { containerStatus: ContainerStatusEnum.SHIPPED } });
        const manager = getManager()


        // console.log(containerInfo);
        // const containersInfo: BlStatusInfo[] = [];

        // if (containerInfo.length > 0) {
        //     const containersInfo: BlStatusInfo[] = [];

        //     for (const container of containerInfo) {
        // get sale order details for sale order id
        //     const soReq: saleOrder = {
        //         saleOrderId: container.saleOrderId
        //     }

        //     const saleOrderDetails = await this.soService.getSaleOrderDetailsById(soReq);
        //     if (!saleOrderDetails) {
        //         throw new ErrorResponse(1111, 'Failed to Get Sale Order');
        //     }
        //     const SaleOrderDropDownData = new SaleOrderDropDownDto(saleOrderDetails.status ? saleOrderDetails.data.saleOrderId : 0, saleOrderDetails.status ? saleOrderDetails.data.saleOrder : "")
        //     const containerData = new BlStatusInfo(container.containerNumber, container.blStatus, SaleOrderDropDownData, (saleOrderDetails?.data?.saleOrder) ? saleOrderDetails.data.saleOrder : '', container.containerId, container.etd, container.oblEtd, container.blNo, saleOrderDetails ? saleOrderDetails.data.poNo : "", saleOrderDetails ? saleOrderDetails.data.finalDestination : "", container.trackingNo);
        //     containersInfo.push(containerData);
        // }

        const query = `select c.sale_order_id as saleOrderId, c.container_number as containerNumber,c.bl_status as blStatus,so.sale_order_no as saleOrder,c.container_id as containerId,c.etd as etd,c.obl_etd as obletd,c.bl_no as blNo,sid.po_number as poNo,sid.destination as finalDestination,c.tracking_no as trackingNo,d.destination_name as destinationName,sid.buyer_po_number as buyerPoNumber from ` + appSettings.logistics_db + `.container c left join ` + appSettings.sales_db + `.sale_order so on so.sale_order_id = c.sale_order_id left join ` + appSettings.sales_db + `.so_invoice_details sid on sid.sale_order_id = c.sale_order_id left join ` + appSettings.masters_db + `.destination d on destination_id = sid.destination where c.status = 'SHIPPED'`

        const data = await manager.query(query)

        const containerData = data.map((i => { return new BlStatusInfo(i.containerNumber, i.blStatus, new SaleOrderDropDownDto(i.saleOrderId, i.saleOrder), i.saleOrder, i.containerId, i.etd, i.oblEtd, i.blNo, i.poNo, i.finalDestination, i.trackingNo, i.destinationName, i.buyerPoNumber) }));

        if (data) {

            return new AllBlStatusInfo(true, 1111, 'Container BL Status Info Found Successfully', containerData);
        } else {
            return new AllBlStatusInfo(false, 1101, 'No Data Found', containerData);

            // throw new ErrorResponse(9999, 'No Data Found')
        }
    }

    async notReceived(containerInfo: DraftReceived): Promise<DraftReceivedResponse> {
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNo,
            blStatus: BlStatusEnum.NOT_RECEIVED,
        })

        if (response.affected) {
            const blStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrder.saleOrderId,
                blStatus: BlStatusEnum.NOT_RECEIVED
            }
            // update sale tracker status
            const blStatusUpdate = await this.soService.updateBlStatus(blStatusInSo);
            return new DraftReceivedResponse(true, 1111, 'Updated to Not Received');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async draftReceived(containerInfo: DraftReceived): Promise<DraftReceivedResponse> {
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            // containerNumber: containerInfo.containerNo,
            blStatus: BlStatusEnum.DRAFT_RECEIVED,
        })

        if (response.affected) {
            const blStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrder.saleOrderId,
                blStatus: BlStatusEnum.DRAFT_RECEIVED,
                soStatus: SaleOrderStatusEnum.IN_PROGRESS
            }
            // update sale tracker status
            const blStatusUpdate = await this.soService.updateBlStatus(blStatusInSo);
            return new DraftReceivedResponse(true, 1111, 'Updated to Draft Received');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async oblReceived(containerInfo: DraftReceived): Promise<DraftReceivedResponse> {
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerNumber: containerInfo.containerNo,
            blStatus: BlStatusEnum.OBL_RECEIVED,
            etd: containerInfo.etd,
            // blNo:containerInfo.blNo,
        })

        if (response.affected) {
            const blStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrder.saleOrderId,
                blStatus: BlStatusEnum.OBL_RECEIVED,
                soStatus: SaleOrderStatusEnum.IN_PROGRESS
            }
            // update sale tracker status
            const blStatusUpdate = await this.soService.updateBlStatus(blStatusInSo);
            return new DraftReceivedResponse(true, 1111, 'Updated to OBL Received');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

    async receivedAndShared(containerInfo: DraftReceived): Promise<DraftReceivedResponse> {
        const response = await this.repository.update({ containerId: containerInfo.containerId }, {
            containerNumber: containerInfo.containerNo,
            blStatus: BlStatusEnum.RECEIVED_AND_SHARED,
        })

        if (response.affected) {
            const blStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrder.saleOrderId,
                blStatus: BlStatusEnum.RECEIVED_AND_SHARED,
                soStatus: SaleOrderStatusEnum.CLOSED
            }
            const soStatusInSo: SoContainerStatusUpdate = {
                saleOrderId: containerInfo.saleOrder.saleOrderId,
                soStatus: SaleOrderStatusEnum.CLOSED
            }
            // update sale tracker status
            const blStatusUpdate = await this.soService.updateBlStatus(blStatusInSo);
            const soStatusUpdate = await this.soService.updateSoStatusForBl(soStatusInSo);
            return new DraftReceivedResponse(true, 1111, 'Updated to Received and Shared');
        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }
    async updateEtd(containerInfo: EtdUpdateRequest): Promise<DraftReceivedResponse> {
        if (containerInfo.type === "etd") {
            const response = await this.repository.update({ containerId: containerInfo.containerId }, {
                etd: containerInfo.etd
            });
            if (response.affected) {
                return new DraftReceivedResponse(true, 1111, 'ETD updated Successfully');
            } else {
                throw new ErrorResponse(9999, 'Failed to update');
            }
        }
        else if (containerInfo.type === "oblEtd") {
            const response = await this.repository.update({ containerId: containerInfo.containerId }, {
                oblEtd: containerInfo.etd
            });
            if (response.affected) {
                return new DraftReceivedResponse(true, 1111, 'ETD updated Successfully');
            } else {
                throw new ErrorResponse(9999, 'Failed to update');
            }
        }

    }
    async updateBlNo(containerInfo: BillNoUpdateRequest): Promise<DraftReceivedResponse> {
        try {
            const response = await this.repository.update({ containerId: containerInfo.containerId }, {
                blNo: containerInfo.blNo
            });
            if (response.affected) {
                return new DraftReceivedResponse(true, 1111, 'BlNo updated Successfully');
            } else {
                throw new ErrorResponse(9999, 'Failed to update');
            }
        }
        catch (err) {
            return err;
        }
    }
    /**
    * To get containerNumber,lineSeal,Eseal
    * @Param saleOrderId
    */
    async getContainerDeatils(soId: ContainerSoIdRequest): Promise<ContainerDetailsResponse> {
        const containerDetails = await this.repository.findOne({ where: { saleOrderId: soId.saleOrderId } });
        console.log(containerDetails);
        if (containerDetails) {
            const modelResponse = new ContainerDetailsModel(containerDetails.containerNumber, containerDetails.lineSeal, containerDetails.eSeal, containerDetails.blNo, containerDetails.scac, containerDetails.bookingNo, containerDetails.containerStatus, containerDetails.referenceNumber, containerDetails.trackingNo, containerDetails.vesselName, containerDetails.portOfTranshipment, containerDetails.portOfDischarge, containerDetails.importingVesselName, containerDetails.dateOfTranshipment, containerDetails.shippedOnboardDate, containerDetails.dischargeDate, containerDetails.destinationDate);
            return new ContainerDetailsResponse(true, 1111, 'Data Received Successfully', modelResponse)
        } else {
            return new ContainerDetailsResponse(false, 1011, 'No Data Found')
        }
    }

    async getLoadingReportDetails(): Promise<AllLoadingReportResponse> {
        const containerDetails = this.repository.createQueryBuilder('Container');
        const containerInfo = await containerDetails.getMany();
        const loadReportData: LoadingReportModel[] = [];
        if (containerInfo.length > 0) {
            for (const container of containerInfo) {
                const custInvoiceDetails = await this.soService.getCustInvoiceDetails({ saleOrderId: container.saleOrderId, plantId: container.unitId });
                console.log('custInvoiceDetails.data' + custInvoiceDetails.data);
                const docApprovalDetails = await this.soService.getDocumentApprovalStatus({ saleOrderId: container.saleOrderId, plantId: container.unitId });
                // console.log('docApprovalDetails'+docApprovalDetails.data);
                const soInspectionDetails = await this.soService.getSoInspectionDetails({ saleOrderId: container.saleOrderId, plantId: container.unitId });

                const SaleOrderItemDetails = await this.soService.getSaleOrderDetailsById({ saleOrderId: container.saleOrderId });
                console.log(SaleOrderItemDetails.data)
                let docStatus
                let isfWorksheetUploaded
                if (docApprovalDetails.status) {
                    isfWorksheetUploaded = docApprovalDetails.data.isfWorksheetUploaded;
                    if (docApprovalDetails.data.simp_uploaded && docApprovalDetails.data.certificate_of_origin_uploaded && docApprovalDetails.data.declaration_of_shrimp_uploaded, docApprovalDetails.data.bLDraftUploaded, docApprovalDetails.data.oblUploaded) {
                        docStatus = true;
                    }
                    else {
                        docStatus = false;
                    }
                }
                else {
                    isfWorksheetUploaded = false;

                }
                let oblStatus;
                if (container.blStatus === BlStatusEnum.DRAFT_RECEIVED) {
                    oblStatus = "NO";
                }
                else if (container.blStatus === BlStatusEnum.NOT_RECEIVED) {
                    oblStatus = "NO";
                }
                else if (container.blStatus === BlStatusEnum.OBL_RECEIVED) {
                    oblStatus = "YES";
                }
                else if (container.blStatus === BlStatusEnum.RECEIVED_AND_SHARED) {
                    oblStatus = "YES";
                }

                let taxAmnt;
                let totalAmount;
                let FOBInRs;
                let FOBInUSD;
                console.log(SaleOrderItemDetails.data.itemData, 'datafffffff')
                for (const item of SaleOrderItemDetails.data.itemData) {
                    const uom = UnitsOfWeightInput.find(uom => uom.value == item.uomId);
                    taxAmnt += (item.netAmount * item.taxPer === null ? 0 : item.taxPer) / 100;
                    let finalNetWeight;
                    let unitPrice;
                    if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                        finalNetWeight = Number(item.netWeight) * 0.454;
                        unitPrice = (Number(item.unitPrice) / 0.454).toFixed(4);
                    } else {
                        finalNetWeight = Number(item.netWeight);
                        unitPrice = Number(item.unitPrice).toFixed(4);
                    }
                    totalAmount += Number(unitPrice) * Number(finalNetWeight);
                }
                FOBInRs = totalAmount - Number(custInvoiceDetails.status ? custInvoiceDetails.data.freightCharges : 0);
                FOBInUSD = (totalAmount - Number(custInvoiceDetails.status ? custInvoiceDetails.data.freightCharges : 0) * Number(custInvoiceDetails.status ? custInvoiceDetails.data.exchangeRate : 0));
                const loadReport = new LoadingReportModel('AZ GEMS INC', 'VISAKHAPATNAM, INDIA', SaleOrderItemDetails.data.finalDestination, container.shippingBillNo, SaleOrderItemDetails.data.actualEtd, container.containerNumber, container.lineSeal, 'CMA CGM LYRA VOY-0TUGZE1MA', container.blNo, container.etd, container.blStatus, SaleOrderItemDetails.data.poNo, '', SaleOrderItemDetails.data.additionalNote, custInvoiceDetails.status ? "YES" : "NO", oblStatus, docApprovalDetails.status ? docApprovalDetails.data.certificateOfOriginUploaded : false, docStatus, container.referenceNumber, soInspectionDetails.status ? soInspectionDetails.data.isChecked : "NO", custInvoiceDetails.status ? custInvoiceDetails.data.totalAmount : 0, SaleOrderItemDetails.data.shippingTerms, FOBInUSD, FOBInRs, taxAmnt, SaleOrderItemDetails.data.saleOrder, container.hoCertificateNo, container.hoCertificateNo === null ? false : true, docApprovalDetails.status ? docApprovalDetails.data.declarationOfShrimpUploaded : false, isfWorksheetUploaded, container.shippingBillNo != null ? true : false, SaleOrderItemDetails.data.paymentTerms, container.insuranceType, SaleOrderItemDetails.data.processingUnit, SaleOrderItemDetails.data.processingUnit, SaleOrderItemDetails.data.endCustomer, 'plant', SaleOrderItemDetails.data.soStatus, container.containerStatus, '-', SaleOrderItemDetails.data.soStatus);
                loadReportData.push(loadReport);
            }
            return new AllLoadingReportResponse(true, 1111, 'Report Details obtained', loadReportData);
        }
        else {
            throw new ErrorResponse(9999, 'No Data Found');
        }


    }

    async updateShipmentDetails(req: ShipmentDetailsDto): Promise<ContainerDetailsResponse> {
        try {
            const containerDetails = await this.repository.findOne({ containerId: req.containerId });
            if (containerDetails != undefined) {
                const updateShipmentDetails = await this.repository.update({ containerId: req.containerId }, { trackingNo: req.trackingNo, vesselName: req.vesselName, portOfTranshipment: req.portOfTranshipment, portOfDischarge: req.portOfDischarge, importingVesselName: req.importingVesselName, dateOfTranshipment: req.dateOfTranshipment, shippedOnboardDate: req.shippedOnboardDate, dischargeDate: req.dischargeDate, destinationDate: req.destinationDate, hoCertificateNo: req.hoCertificateNo, hoIssuedDate: req.hoIssuedDate, vcNo: req.vcNo, documentDispatchStatus: req.documentDispatchStatus, documentDispatchDate: req.documentDispatchDate, couriourNo: req.couriourNo, insuranceType: req.insuranceType, shippingBillNo: req.shippingBillNo, insuranceId: req.insuranceId, insuranceDate: req.insuranceDate, referenceNo: req.referenceNo, insuranceAmount: req.insuranceAmount, shippingBillDate: req.shippingBillDate, bookingNo: req.bookingNo, scac: req.scac });
                if (updateShipmentDetails.affected > 0) {
                    return new ContainerDetailsResponse(true, 1001, "Shipment details updated successfully. ");
                }
                else {
                    return new ContainerDetailsResponse(false, 1001, "Shipment details updated successfully. ");
                }
            }
            else {
                return new ContainerDetailsResponse(false, 1001, "Container Details not found. ");
            }
        } catch (err) {
            return err;
        }
    }

    async getShipmentDetails(req: ContainerIdRequest): Promise<ShippmentDetailsResponse> {
        try {
            const getShippmentDetails = await this.repository.findOne({ containerId: req.containerId });
            if (getShippmentDetails != undefined) {
                const data = new ShipmentDetailsDto(getShippmentDetails.containerId, getShippmentDetails.containerNumber, getShippmentDetails.dateOfTranshipment, getShippmentDetails.destinationDate, getShippmentDetails.dischargeDate, getShippmentDetails.importingVesselName, getShippmentDetails.portOfDischarge, getShippmentDetails.portOfTranshipment, getShippmentDetails.shippedOnboardDate, getShippmentDetails.trackingNo, getShippmentDetails.vesselName, getShippmentDetails.hoCertificateNo, getShippmentDetails.hoIssuedDate, getShippmentDetails.vcNo, getShippmentDetails.documentDispatchStatus, getShippmentDetails.couriourNo, getShippmentDetails.documentDispatchDate, getShippmentDetails.insuranceType, getShippmentDetails.shippingBillNo, getShippmentDetails.insuranceId, getShippmentDetails.insuranceDate, getShippmentDetails.referenceNo, getShippmentDetails.insuranceAmount, getShippmentDetails.shippingBillDate, getShippmentDetails.bookingNo,getShippmentDetails.scac);
                return new ShippmentDetailsResponse(true, 1001, "Shippment Details retrived successfully. ", data);
            }
            else {
                return new ShippmentDetailsResponse(false, 1010, "No data found. ");
            }
        }
        catch (err) {
            return err;
        }
    }

    async getContainerReportData(): Promise<ContainerReportResponse> {
        const containerdata = await this.containerLogRepo.getContainerReportData();
        if (!containerdata.length) {
            throw new ErrorResponse(9999, 'No Data Found');
        }
        const statusMap: Map<ContainerStatusEnum | BlStatusEnum | string, Map<number, number>> = new Map();
        const plantsSet: Set<number> = new Set();
        for (const [key, value] of Object.entries(ContainerStatusEnum)) {
            statusMap.set(value, new Map());
        }
        for (const [key, value] of Object.entries(BlStatusEnum)) {
            statusMap.set(value, new Map());
        }
        containerdata.forEach(rec => {
            if (!statusMap.has(rec.status)) {
                statusMap.set(rec.status, new Map());
            }
            if (!statusMap.get(rec.status).has(rec.unit_id)) {
                statusMap.get(rec.status).set(rec.unit_id, rec.qty ? rec.qty : 0);
            }
            plantsSet.add(rec.unit_id);
        });
        const data: ContainerReportModel[] = [];
        for (const [status, plantMap] of statusMap.entries()) {
            const plantsData: ContainerReportPlantsData[] = []
            let total = 0;
            plantsSet.forEach(plant => {
                const qty = Number(plantMap.get(plant) ? plantMap.get(plant) : 0);
                total += qty;
                plantsData.push(new ContainerReportPlantsData(plant, qty));
            })
            data.push(new ContainerReportModel(status, plantsData, total));
        }
        return new ContainerReportResponse(true, 1, '', data);
    }

    async getLogisticsLifeCycleData(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = 'SELECT container_status AS STATUS ,SUM(IF(unit_id = 1, 1, 0)) AS kakinada,SUM(IF(unit_id=2, 1,0))AS unitone,SUM(IF(unit_id  = 3, 1, 0)) AS unittwo,COUNT(st.container_status) AS total FROM `erpx_dev_sales`.`sale_order_track` st  LEFT JOIN `erpx_dev_logistics`.`container` C ON C.sale_order_id=st.sale_order_id WHERE st.so_status NOT IN("CLOSE","CANCEL") GROUP BY container_status UNION ALL SELECT st.bl_status ,SUM(IF(unit_id = 1, 1, 0)) AS kakinada,SUM(IF(unit_id=2, 1,0))AS unitone,SUM(IF(unit_id  = 3, 1, 0)) AS unittwo,COUNT(st.bl_status) AS total  FROM `erpx_dev_sales`.`sale_order_track` st LEFT JOIN `erpx_dev_logistics`.`container` C ON C.sale_order_id=st.sale_order_id WHERE st.so_status NOT IN("CLOSE","CANCEL") GROUP BY st.bl_status'
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
            } else {
                return new CommonResponse(false, 1111, "Error occure")

            }

        } catch (err) {
            return err;
        }
    }
    async getMonthWiseContainersData(req: ContainerYearRequest): Promise<ContainerBarChartResponseModel> {
        try {
            const manager = getManager();
            let query = 'SELECT MONTHNAME(st.dispatched_date)AS MONTH,COUNT(si.sale_order_id) AS containers,SUM(IF(u.uom_name = "OZ" ,ROUND (si.dispatched_qty * si.pouches * si.pouch_weight * 0.0625), IF(u.uom_name = "KG" ,ROUND(si.dispatched_qty * si.pouches * si.pouch_weight*2.204),IF(uom_name = "GM" ,ROUND(si.dispatched_qty * si.pouches * si.pouch_weight * 0.0022),ROUND(si.dispatched_qty * si.pouches * si.pouch_weight)))))AS quantity FROM ' + appSettings.sales_db + '.sale_order_track st LEFT JOIN ' + appSettings.sales_db + '.sale_order_items si ON si.sale_order_id = st.sale_order_id LEFT JOIN ' + appSettings.masters_db + '.uoms u ON u.uom_id = si.uom_id WHERE st.container_status ="Shipped" AND dispatched_date IS NOT NULL AND YEAR(st.dispatched_date)=' + req.year + ' GROUP BY MONTH(st.dispatched_date)';
            // if(req.year){
            //     query=query + ' and YEAR(st.dispatched_date) = ' +req.year ;
            // }
            const result: ContainerBarChartDto[] = await manager.query(query)
            if (result) {
                return new ContainerBarChartResponseModel(true, 1111, "Data retreived sucesssfuly", result)
            } else {
                return new ContainerBarChartResponseModel(false, 1111, "Error occure")

            }

        } catch (err) {
            return err;
        }

    }
    async getTopFiveDestinations(): Promise<CommonResponse> {
        const todayDate = moment().format("DD-MM-YYYY")
        const currentMonth = moment(todayDate).get('month')
        const lastYear = moment().subtract(1, 'year').get('year')
        const currentYear = moment().get('year')
        let fromDate;
        if (currentMonth < 4) {
            fromDate = '01-04-' + lastYear
        } else {
            fromDate = '01-04-' + currentYear
        }
        console.log(fromDate, 'fromDate')

        try {
            const manager = getManager();
            let query = ' SELECT d.destination_name AS destination, COUNT(d.destination_name) AS count FROM ' + appSettings.sales_db + '.so_invoice_details s LEFT JOIN ' + appSettings.masters_db + '.destination d ON s.destination = d.destination_id LEFT JOIN ' + appSettings.masters_db + '.unitcodes uc ON uc.unit_code_id = s.factoryId LEFT JOIN ' + appSettings.sales_db + ' .sale_order_track st ON s.sale_order_id=st.sale_order_id WHERE st.container_status = "SHIPPED" AND st.dispatched_date BETWEEN ' + fromDate + ' AND NOW() GROUP BY destination ORDER BY COUNT(destination) DESC LIMIT 5';
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)

            } else {
                return new CommonResponse(false, 1111, "Error occure")

            }
        } catch (err) {
            return err;

        }
    }
    async gettotalsaleorderShipped(req: ContainerYearRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = 'SELECT MONTHNAME(dispatched_date) AS name,COUNT(sale_order_id) AS y,MONTHNAME(dispatched_date) AS drilldown FROM ' + appSettings.sales_db + '.`sale_order_track` WHERE so_status="CLOSED" AND dispatched_date IS NOT NULL AND YEAR(dispatched_date) =' + req.year + ' GROUP BY MONTHNAME(dispatched_date) ORDER BY MONTH(dispatched_date)';
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data Retreived sucessfully", result)
            } else {
                return new CommonResponse(false, 1111, "Error occure")
            }
        } catch (err) {
            return err;
        }
    }
    async totalsaleordersshiipedinyear(req: ContainerYearRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = 'SELECT COUNT(sale_order_id) as total FROM ' + appSettings.sales_db + '.sale_order_track WHERE so_status="CLOSED" AND dispatched_date IS NOT NULL AND YEAR(dispatched_date)=' + req.year + '';
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data Retreived sucessfully", result)
            } else {
                return new CommonResponse(false, 1111, "Error occure")
            }
        } catch (err) {
            return err;
        }
    }
    async totalsaleordersShippedinDayWise(req: ContainerYearRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT NAME as name,id,CONCAT('[',GROUP_CONCAT(CONCAT('["',DAY,'",',cnt,']')  ORDER BY DAY DESC SEPARATOR ','),']') AS data FROM (SELECT MONTH(dispatched_date) AS MONTH, MONTHNAME(dispatched_date) AS NAME, MONTHNAME(dispatched_date) AS id ,COUNT(sale_order_id) cnt,DATE(dispatched_date) DAY FROM erpx_dev_sales.sale_order_track WHERE so_status='CLOSED' AND dispatched_date IS NOT NULL AND YEAR(dispatched_date) = ` + req.year + ` GROUP BY MONTH(dispatched_date), DAY(dispatched_date)ORDER BY DAY(dispatched_date)) q GROUP BY NAME ORDER BY MONTH`
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data Retrieved sucessfully", result)
            } else {
                return new CommonResponse(false, 1111, "Error occured")
            }
        } catch (err) {

            return err;

        }
    }


    async getLogisticsDailUsage() {
        try {
            const manager = getManager();
            const query = `select count(*) as count,cl.status as containerStatus,c.unit_id as unitId,uc.unit_name as unitName from ${appSettings.logistics_db}.container_log cl
         left join ${appSettings.logistics_db}.container c on c.container_id = cl.container_id 
         left join ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id = c.unit_id
         where DATE(cl.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)
         group by cl.status,c.unit_id `
            const data = await manager.query(query)
            console.log(data)
            const time = moment().subtract(1, "days").format('MMMM Do, YYYY')
            // console.log(data)
            const groupByStatus = data.reduce((group, containerData) => {
                const { containerStatus } = containerData;
                group[containerStatus] = group[containerStatus] ?? [];
                group[containerStatus].push(containerData ? containerData : 'no data')
                return group;
            }, {})
            console.log(groupByStatus)
            const message = Object.keys(groupByStatus).length ? (`Logistics usage on ${time} \n` + Object.keys(groupByStatus).map((key) => {
                return `\n*${key}:*\n  ${groupByStatus[key].map((el) => { return el.unitName + ':' + el.count + '\n' })}`
            })) : (`Logistics usage on ${time} \n\n *No data found for all units*`)
            const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(35, message.toString(), [whatsApp.UsageReport]));
            if (messageStatus.status) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully", messageStatus)
            } else {
                return new CommonResponse(false, 11108, "Error while sending message", messageStatus)
            }
        } catch (error) {
            return new CommonResponse(false, 11508, "Error while sending message")
        }
    }

    @Cron('1 * * * *')
    async getLogisticsDailyUsage() {
        const manager = getManager();
        const time = moment().subtract(1, "days").format('MMMM Do, YYYY')
        const units = [{ unitName: 'Kakinada', id: 1 }, { unitName: 'Unit 1', id: 2 }, { unitName: 'Unit 2', id: 3 }, { unitName: 'Head Office', id: 5 }]
        const query = `SELECT c.unit_id as unitId,
            SUM(IF( cl.status = 'BOOKED',1,0)) AS booked ,
            SUM(IF( cl.status = 'SHIPPED',1,0)) AS shipped ,
            SUM(IF( cl.status = 'DISPATCHED TO PLANT',1,0)) AS dispatchedToPlant ,
            SUM(IF( cl.status = 'LOADED AND SEALED',1,0)) AS loadedAndSealed ,
            SUM(IF( cl.status = 'LOADING',1,0)) AS loading ,
            u.unit_name AS unit FROM container_log cl
            LEFT JOIN container c ON c.container_id = cl.container_id 
            LEFT JOIN erpx_dev_masters.unitcodes u ON u.unit_code_id = c.unit_id
            where DATE(cl.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)
            GROUP BY c.unit_id`

        const containerData = await manager.query(query);
        const inVoicesQuery = `SELECT i.unit_id as unitId,COUNT(*)AS invoiceCount,uc.unit_name AS unitName FROM erpx_dev_sales.customer_invoice i
        LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id=i.unit_id 
        where DATE(i.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)
        GROUP BY i.unit_id`

        const invoicesData = await manager.query(inVoicesQuery)

        let invoicesCount = '';
        let unitWiseData = '';
        let bookedData = '';
        let shippedData = '';
        let oblData = '';
        let invoiceData = '';
        let docApprovalPendData = '';

        for (const u of units) {
            const unitWisefilteredData = containerData.filter((i) => i.unitId == u.id)
            unitWiseData += `*${u.unitName}:* ` + ((unitWisefilteredData.length > 0) ? (unitWisefilteredData.map((el) => { return ` \\n BOOKED : ${el.booked} \\n SHIPPED : ${el.shipped} \\n DISPATCHED TO PLANT : ${el.dispatchedToPlant} \\n LOADED AND SEALED : ${el.loadedAndSealed} \\n LOADING : ${el.loading} \\n\\n` })) : (` \\n BOOKED : ${0} \\n SHIPPED : ${0} \\n DISPATCHED TO PLANT : ${0} \\n LOADED AND SEALED : ${0} \\n LOADING : ${0} \\n \\n`));

            const unitWiseInvoiceData = invoicesData.filter((i) => i.unitId == u.id);
            invoicesCount += `*${u.unitName}:* ` + ((unitWiseInvoiceData.length > 0) ? (unitWiseInvoiceData[0].invoiceCount + "\\n") : (0 + "\\n"))
        }
       

        const message = `*Logistics usage on ${time}*\\n *CONTAINER STATUS* \n\n ${unitWiseData} \\n *INVOICES COUNT*\\n\\n ${invoicesCount} `
        // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(35, message.toString(), [whatsApp.UsageReport]));
        const parameters = [
            { "type": "text", "text": time + ` (${whatsApp.server})` },
            { "type": "text", "text": unitWiseData },
            { "type": "text", "text": invoicesCount },
            // { "type": "text", "text": "No Data" },
            // { "type": "text", "text": "No Data" },
            // { "type": "text", "text": "No Data" },
           
        ]
        const contacts = whatsApp.contacts
        let statusFlag = true
        for (const contact of contacts) {
            const req = await new MessageParameters(contact, 'logistics_report', parameters, "en_us")
            const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            console.log(messageStatus)
            if (!messageStatus.status) {
                statusFlag = false
            }
            else{
                statusFlag = true
                const whatsapplogDto = new WhatsAppLogDto(contact,'logistics_report','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.logisticsmoduleId)
                await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
               
            }
        }
        if (statusFlag) {
            return new CommonResponse(true, 11108, "Message Sent Sucessfully")
        } else {
            return new CommonResponse(false, 11108, "Error while sending message")
        }
    }

    async getSoIdsByStatus(soId: ContainerStatusRequest): Promise<CommonResponse> {
        const manager = getManager();
        const data = "Select DISTINCT(sale_order_id) AS soIds from "+appSettings.logistics_db+".container c where status = 'SHIPPED'"
        const containerDetails = await manager.query(data);
        console.log(containerDetails);
        if (containerDetails) {
            return new CommonResponse(true, 1111, 'Data Received Successfully', containerDetails)
        } else {
            return new CommonResponse(false, 1011, 'No Data Found')
        }
    }
    
}



